import { render, staticRenderFns } from "./usrcard.vue?vue&type=template&id=37ed06c2&scoped=true"
import script from "./usrcard.vue?vue&type=script&lang=js"
export * from "./usrcard.vue?vue&type=script&lang=js"
import style0 from "./usrcard.vue?vue&type=style&index=0&id=37ed06c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed06c2",
  null
  
)

export default component.exports